import type { CyFunActivity } from "@/types/maturity";
import { DOMAINS_META } from "@/utils/maturity-colors";

type DomainProgress = {
  answered: number;
  total: number;
};

type FullEvalDomainTabsProps = {
  activities: CyFunActivity[];
  activeDomain: number;
  onDomainChange: (index: number) => void;
  domainProgress: DomainProgress[];
};

function FullEvalDomainTabs({
  activities,
  activeDomain,
  onDomainChange,
  domainProgress,
}: FullEvalDomainTabsProps) {
  return (
    <div
      className="flex rounded-xl p-1 w-full"
      style={{ background: "#F1F5F9" }}
    >
      {activities.map((activity, index) => {
        const isActive = activeDomain === index;
        const progress = domainProgress[index];
        const isComplete =
          progress &&
          progress.total > 0 &&
          progress.answered === progress.total;
        const domainMeta = DOMAINS_META.find((d) => d.id === activity.code);
        const accentColor = domainMeta?.color ?? "#6B7280";

        return (
          <button
            key={activity.code}
            type="button"
            onClick={() => onDomainChange(index)}
            title={activity.name}
            aria-label={`${activity.name} — ${progress?.answered ?? 0} din ${progress?.total ?? 0} completate`}
            className="flex-1 py-2.5 px-1 rounded-lg transition-all duration-150 text-center"
            style={{
              background: isActive ? "#fff" : "transparent",
              boxShadow: isActive ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
            }}
          >
            <div
              className="text-xs font-bold tracking-wide truncate"
              style={{ color: isActive ? accentColor : "#94A3B8" }}
            >
              {activity.name.split(":")[0]}
            </div>
            <div className="mt-1 flex items-center justify-center">
              {isComplete ? (
                <span
                  className="inline-flex items-center justify-center w-5 h-5 rounded-full text-white text-[10px] font-bold"
                  style={{ backgroundColor: "#059669" }}
                >
                  ✓
                </span>
              ) : (
                <span
                  className="text-[10px] font-mono"
                  style={{ color: isActive ? accentColor : "#CBD5E1" }}
                >
                  {progress?.answered ?? 0}/{progress?.total ?? 0}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default FullEvalDomainTabs;
